import OrderTransportingOrderForwardingListResponse, {
  OrderTransportingOrderForwardingListResponseItemContract,
  OrderTransportingOrderForwardingListResponseItem,
} from "../../../../../api/raily/order/transporting-order/forwarding/list/order-transporting-order-forwarding-list.response";
import OrderTransportingOrderForwardingList, {
  OrderTransportingOrderForwardingListItem,
  OrderTransportingOrderForwardingListItemContract,
} from "./order-transporting-order-forwarding-list";

const createDataItemContract = (
  contract: OrderTransportingOrderForwardingListResponseItemContract,
): OrderTransportingOrderForwardingListItemContract => {
  return {
    consumerTaxiId: contract.consumerTaxiId,
    producerTaxiId: contract.producerTaxiId,
  };
};

const createDataItem = (
  responseItem: OrderTransportingOrderForwardingListResponseItem,
): OrderTransportingOrderForwardingListItem => {
  return {
    contract: createDataItemContract(responseItem.contract),
    id: responseItem.id,
  };
};

const createData = (
  responseData: OrderTransportingOrderForwardingListResponseItem[],
): OrderTransportingOrderForwardingListItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: OrderTransportingOrderForwardingListResponse,
): OrderTransportingOrderForwardingList => {
  return {
    data: createData(response.data),
  };
};

const orderTransportingOrderForwardingListFactory = {
  create,
};

export default orderTransportingOrderForwardingListFactory;
